<template>
  <div>
    <div>
      <div class="formPosition">
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <template>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-container class="text-md-left">
              <v-row no-gutters>
                <v-col md="12">
                  <v-card>
                    <v-list flat>
                      <v-header>
                        <v-row>
                          <v-col md="12">
                            <v-row>
                              <v-col md="6">
                                <v-card-title
                                  >Lançamento de nota Votada</v-card-title
                                >
                              </v-col>
                              <v-col md="5">
                                <div
                                  :style="estiloPauta"
                                  v-if="$store.state.hasMessage"
                                  :class="$store.state.classMessage"
                                >
                                  {{ $store.state.textMessage }}
                                </div>
                              </v-col>
                            </v-row>
                            <v-card-text>
                              <v-row>
                                <v-col md="4">
                                  <v-combobox
                                    :items="classes"
                                    v-model="classeSelected"
                                    item-text="descricao"
                                    label="Selecionar a classe"
                                    return-object
                                    @change="filtrarTurmas()"
                                    placeholder="Selecione a classe"
                                  >
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox
                                    :items="turmasFilter"
                                    v-model="turmaSelected"
                                    item-text="descricao"
                                    label="Selecionar a Turma"
                                    @change="findDisciplinaInProfDisc()"
                                    placeholder="Selecione a turma"
                                  >
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox
                                    :items="disciplinas"
                                    v-model="disciplinaSelected"
                                    @change="pautaByTurma()"
                                    item-text="descricao"
                                    label="Selecionar a Disciplina"
                                    placeholder="Selecione a disciplina"
                                    return-object
                                  >
                                  </v-combobox>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-header>

                      <v-list-item-group
                        v-model="item"
                        color="primary"
                        style="width: 100%"
                      >
                        <!--  1 e 2 trimestre  header -->
                        <v-row
                          style="
                            background-color: #ccc;
                            margin-left: 0px;
                            width: 100%;
                          "
                          v-if="listEstudantfromPauta.length"
                        >
                          <v-col cols="12" sm="12" md="1">N.</v-col>
                          <v-col cols="12" sm="12" md="7">Nome</v-col>

                          <v-col cols="12" sm="12" md="1">Nota</v-col>

                          <v-col cols="12" sm="12" md="2">Acção</v-col>

                          <v-col cols="12" sm="12" md="1">Autor</v-col>
                        </v-row>

                        <hr v-if="listEstudantfromPauta.length" />
                        <br />

                        <!-- end  list  header  -->

                        <v-list-item
                          v-for="(item, i) in listEstudantfromPauta"
                          :key="i"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <!-- body 1  trimestre -->

                          <v-row>
                            <v-col cols="12" sm="12" md="1">{{ i + 1 }}.</v-col>

                            <v-col cols="12" sm="12" md="7">
                              <v-list-item-title
                                v-text="item.nome"
                              ></v-list-item-title>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p
                                v-if="editedpk !== item.pkpauta"
                                class="text-lowercase"
                              >
                                {{ item.votada }}
                              </p>
                              <v-text-field
                                :rules="notaRules"
                                v-if="editedpk === item.pkpauta"
                                v-model="editedItem.votada"
                                single-line
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="2">
                              <v-btn color="red" fab x-small dark v-if="pautaBloqueada" class="mr-2" text>
                                <v-icon>block</v-icon>
                              </v-btn>
                              <v-btn
                                color="secondary"
                                fab
                                x-small
                                dark
                                :disabled="btn_activacao1"
                                v-if="!pautaBloqueada && editedpk !== item.pkpauta"
                                class="mr-2"
                                @click="bt_edit(item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>

                              <v-btn
                                color="primary"
                                fab
                                x-small
                                dark
                                v-if="editedpk === item.pkpauta"
                                @click="bt_save(editedItem)"
                              >
                                <v-icon>save_alt</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <span style="font-size: 8px"
                                >{{ item.autor }}--{{ item.data_2 }}</span
                              >
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../plugins/axios";
const ls = require("local-storage");
export default {
  data: () => ({
    formValid: true,
    estiloPauta: "position:fixed;background-color:green;color:white;",
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      (v) => (v >= 0 && v <= 20) || "nota invalida",
      (v) => !isNaN(v) || "not number ",
      (value) => {
        const pattern = /^[+-]?\d+(\.\d+)?$/;
        return pattern.test(value) || "Invalido.";
      },
      (v) => v.length <= 4 || "valor inválido",
    ],
    text: "",
    editedpk: false,
    profediscinas: [],
    role_usuario: "",
    progresso_2: false,
    overlay: false,
    disciplinas: [],
    _classe: "",
    Professor: "",
    dialog: false,
    dialogoDisabilita: false,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: "",
    tumaSelect: "",
    iddisciplina: 0,
    btn_description: "",
    publicar_status: false,
    idturma: 0,
    progresso_3: false,
    closeOnClick: true,
    progresso: true,
    item: 1,
    classes: [{ id: 1, descricao: "10ª classe" },{ id: 2, descricao: "11ª classe" },{ id: 3, descricao: "12ª classe" },{ id: 4, descricao: "13ª classe" }],
    classeSelected: null,
    disciplinaSelected: null,
    turmaSelected: null,
    disciplinaSelected: null,
    turmasFilter: [],
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      recurso: 0,
      votada:0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0,
    },
    objBloqueioPauta: [],
    pautaBloqueada: false,
  }),
  computed: {
    idclasse() {
      return this.$store.state.idclasse;
    },
    role() {
      return ls.get("role");
    },
  },

  watch: {
    listaDeClassesPorLancarNotas() {
      this.$store.state.isloading = false;
    },
  },
  created() {
    this.turmaFindWithEstudanteCount("all");
    this.initprofdisc();
    this.role_usuario = ls.get("role");
  },

  methods: {
    async CarregaPautas() {
      this.overlay = true;
      try {
        let params = {
          disciplina: this.$store.state.disciplina,
          turma: this.$store.state.objturma,
          trimestre: 3,
        };

        let results = await axios.post("/ListarPautaBloqueada", params)
        .then((res) => res.data);
        if (results.length) {
          this.objBloqueioPauta = results[0];
          this.pautaBloqueada = true;
        } else {
          this.pautaBloqueada = false;
        }
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.overlay = false;
      }
    },

    classe(idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = "10ª Classe";
      }
      if (idanoacademico === 2) {
        this._classe = "11ª Classe";
      }
      if (idanoacademico === 3) {
        this._classe = "12ª Classe";
      }
      if (idanoacademico === 4) {
        this._classe = "13ª Classe";
      }

      this.idanoacademico = idanoacademico;
    },
    loadprogressbar() {
      this.$store.state.isloading = true;
    },

    bt_edit(item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedpk = item.pkpauta;
      this.editedItem.trimestre = this.$store.state.idperfilpauta;
      this.editedItem.pkpauta = item.pkpauta;

      setTimeout(() => {}, 1000);
    },
    MostrarDialogo() {
      this.dialog = true;
    },

    MostrarDialogoDisabilitar() {
      this.dialogoDisabilita = true;
    },
    bt_save(editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      if (this.formValid) {
        this.save(editedItem);

        this.editedpk = 0;
      }
      setTimeout(() => {}, 1000);
    },
    backTodisciplinList() {
      this.listEstudantfromPauta = [];
    },
    backToTurmaList() {
      this.disciplinas = [];
    },

    filtrarTurmas() {
      this.overlay = true;
      this.turmasFilter = [];
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      this.turmaSelected = null;
      this.turmasFilter = this.listaDeClassesPorLancarNotas.filter(
        (t) => t.idAno_Academico === this.classeSelected.id
      );
      this.overlay = false;
    },

    async turmaFindWithEstudanteCount(idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get("/turmaFindWithEstudanteCount/" + "all") // idclasse JyUn JQ==
          .then((res) => res.data);
        this.progresso = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
      this.listEstudantfromPauta = [];
    },
    async save(editedItem) {
      if (this.role === "ROLE_ADM") {
        this.estiloPauta = "position:fixed;background-color:red;color:white;";
        this.$store.dispatch("textMessage", {
          msg: "Não é permitido ao administrador Lançar Notas ou altera-las.",
          classMessage: "msgError",
          timeout: 8000,
        });
      } else {
        const ls = require("local-storage");
        var params = {
          p1_notaMac: editedItem.p1_notaMac,
          p1_nota: editedItem.p1_nota,
          p1_nota2: editedItem.p1_nota2,
          p1_MD: editedItem.p1_MD,
          p2_notaMac: editedItem.p2_notaMac,
          p2_nota: editedItem.p2_nota,
          p2_nota2: editedItem.p2_nota2,
          p2_MD: editedItem.p2_MD,
          p3_notaMac: editedItem.p3_notaMac,
          p3_nota: editedItem.p3_nota,
          p3_MD: editedItem.p3_MD,
          pg: editedItem.pg,
          ca: editedItem.ca,
          mfd: editedItem.mfd,
          autor: ls.get("nomeUsuario"),
          pkpauta: editedItem.pkpauta,
          trimestre: editedItem.trimestre,
          recurso:
            editedItem.recurso !== null && editedItem.recurso.length <= 2
              ? editedItem.recurso + ".0"
              : editedItem.recurso,
              votada:
            editedItem.votada !== null && editedItem.votada.length <= 2
              ? editedItem.votada + ".0"
              : editedItem.votada,
        };

        try {
          let msg = await axios
            .post("/lancarNotaVotada", params)
            .then((res) => res.data);
          // this.text = msg[1].insertId
          this.text = msg;

          try {
            if (msg.affectedRows >= 0) {
              this.text = 1 + " gravado(s) com sucesso";
              this.$store.dispatch("textMessage", {
                msg: this.text,
                classMessage: "msgSucess",
                timeout: 2000,
              });

              Object.assign(
                this.listEstudantfromPauta[this.editedIndex],
                params
              );
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage;
            this.$store.dispatch("textMessage", {
              msg: this.text,
              classMessage: "msgError",
              timeout: 8000,
            });
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage;
            this.$store.dispatch("textMessage", {
              msg: this.text,
              classMessage: "msgError",
              timeout: 8000,
            });
          } catch (error) {}

          if (this.editedIndex > -1) {
            //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.push(this.editedItem);
            // console.log("this.editedItem: "+this.editedItem.nome)
          }
          //  this.close();
        } catch (error) {
          console.log("eroooo: " + error);
          this.isLoading = false;

          this.text = error.message;
          this.$store.dispatch("textMessage", {
            msg: this.text + " - " + error,
            classMessage: "msgError",
            timeout: 8000,
          });
        } finally {
        }
      }
    },

    async pautaByTurma() {
      // carrega turma apartir de bauta  Turma
      let obj = this.disciplinaSelected;
      this.$store.state.disciplina = obj.iddisciplina;
      this.$store.state.objDisciplina = obj;
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get("i_id") +
        '"  }';

      try {
        this.overlay = true;
        this.listEstudantfromPauta = await axios

          .get("/listEstudantfromPauta/" + payload)
          .then((res) => res.data);

        this.overlay = false;
        this.MostraProfessor();
        this.CarregaPautas()
      } catch (error) {
        // this.isLoading = false
        this.overlay = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initprofdisc(search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}';
        } else {
          var payload = '{"find":"' + search + '"}';
        }
        this.profediscinas = await axios
          .get("/professordiscFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },
    async PublicarPauta() {
      const valores = {
        turma:
          this.$store.state.objturma.descricao +
          "-" +
          this.$store.state.objturma.pkTurma,
        disciplina: this.$store.state.disciplina,
        trimestre: this.$store.state.lancarNotaDe,
        bloquear: 1,
        publicar: 1,
        idControlopauta: 0,
      };

      // Consumindo a API
      try {
        let valor = await axios

          .post("/bloquearPauta", valores)
          .then((res) => res.data);
        let text = "Pauta publicada com sucesso";
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgSucess",
          timeout: 8000,
        });
        this.dialog = false;

        this.$store.state.bloqueado.push(valores);
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.verificaPautas();
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async DesbloquearPauta() {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores = {
          turma:
            this.$store.state.objturma.descricao +
            "-" +
            this.$store.state.objturma.pkTurma,
          disciplina: this.$store.state.disciplina,
          trimestre: this.$store.state.lancarNotaDe,
          bloquear: 0,
          publicar: 0,
          idControlopauta: this.$store.state.Controlopauta,
        };

        try {
          let valor = await axios

            .post("/bloquearPauta", valores)
            .then((res) => res.data);
          let text = "Pauta Bloqueada com sucesso";
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgSucess",
            timeout: 8000,
          });
          this.dialog = false;

          this.$store.state.bloqueado = [];
          // CarregaPauta
          this.verificaPautas();

          this.dialogoDisabilita = false;
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch("textMessage", {
            msg: error,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    MostraProfessor() {
      let valor = this.profediscinas.filter(
        (d) => d.iddisciplina === this.$store.state.disciplina
      );
      if (valor.length) {
        this.Professor = valor[0].nome;
        this.descricao_Prof = "disciplina atrbuida ao Professor";
      } else {
        this.Professor = "Sem Professor Associado";
        this.descricao_Prof = "";
      }
    },

    HabilitaBotoes(valor) {
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "1º Trimestre")
      ) {
        this.btn_activacao1 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "2º Trimestre")
      ) {
        this.btn_activacao2 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "3º Trimestre")
      ) {
        this.btn_activacao3 = valor;
      }
    },

    verificaPautas() {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(
        (block) =>
          block.turma ===
            this.$store.state.objturma.descricao +
              "-" +
              this.$store.state.objturma.pkTurma &&
          block.disciplina == this.$store.state.disciplina &&
          block.publicar == 1 &&
          block.bloquear == 1 &&
          block.trimestre === this.$store.state.lancarNotaDe
      );
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true);

        this.$store.state.Controlopauta =
          this.listaPautasBloquadas[0].idControlopauta;
        if (ls.get("role") === "ROLE_PROF") {
          this.publicar_status = true;
          this.btn_description = "Mini Pauta Bloqueada";
        } else {
          this.publicar_status = true;
          this.HabilitaBotoes(false);
          this.btn_description = "Mini Pauta Bloqueada";
        }
      } else {
        this.publicar_status = false;
        this.btn_description = "Bloquear";
        this.HabilitaBotoes(false);
      }
    },

    async findDisciplinaInProfDisc() {
      this.overlay = true;
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      let obj = this.turmaSelected;
      this.disciplinas = [];
      this.$store.state.turma = obj.descricao;
      this.$store.state.objturma = obj;
      try {
        this.progresso_2 = true;
        this.disciplinas = await axios
          .get(
            "/findDisciplinaInProfDisc/" + obj.pkTurma + "/" + obj.anoLectivo
          )
          .then((res) => res.data);
        this.progresso_2 = false;
        this.overlay = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false;
        this.overlay = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
